import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { ArrowLeft, PaperPlaneTilt } from '@phosphor-icons/react';
import Logo from '../components/Logo';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ContactPage() {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error('Compila nome, email e messaggio');
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      toast.success('Messaggio inviato!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nell\'invio');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-zinc-100 px-4 sm:px-6 py-4 flex items-center gap-4">
        <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-zinc-900">
          <ArrowLeft size={20} />
        </button>
        <Logo size="sm" />
      </header>

      <main className="max-w-lg mx-auto px-4 sm:px-6 py-12">
        {sent ? (
          <div className="text-center py-12" data-testid="contact-success">
            <PaperPlaneTilt size={48} weight="bold" className="mx-auto text-teal-600 mb-4" />
            <h1 className="text-2xl font-black tracking-tight mb-2">Messaggio inviato!</h1>
            <p className="text-zinc-500 text-sm mb-6">Ti risponderemo al più presto a {form.email}</p>
            <Button onClick={() => navigate(-1)} className="rounded-none bg-zinc-900 hover:bg-zinc-800 text-white font-bold">
              Torna indietro
            </Button>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-black tracking-tight mb-2" data-testid="contact-title">Contattaci</h1>
            <p className="text-sm text-zinc-500 mb-8">Hai domande o suggerimenti? Scrivici e ti risponderemo al più presto.</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Nome *</label>
                <Input
                  value={form.name}
                  onChange={e => setForm({...form, name: e.target.value})}
                  className="rounded-none mt-1"
                  placeholder="Il tuo nome"
                  required
                  data-testid="contact-name-input"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Email *</label>
                <Input
                  type="email"
                  value={form.email}
                  onChange={e => setForm({...form, email: e.target.value})}
                  className="rounded-none mt-1"
                  placeholder="La tua email"
                  required
                  data-testid="contact-email-input"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Oggetto</label>
                <Input
                  value={form.subject}
                  onChange={e => setForm({...form, subject: e.target.value})}
                  className="rounded-none mt-1"
                  placeholder="Di cosa si tratta?"
                  data-testid="contact-subject-input"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Messaggio *</label>
                <textarea
                  value={form.message}
                  onChange={e => setForm({...form, message: e.target.value})}
                  className="w-full border border-zinc-300 px-3 py-2 text-sm mt-1 focus:outline-none focus:border-zinc-900 min-h-[150px] resize-y"
                  placeholder="Scrivi il tuo messaggio..."
                  required
                  data-testid="contact-message-input"
                />
              </div>
              <Button
                type="submit"
                disabled={sending}
                className="w-full rounded-none bg-zinc-900 hover:bg-zinc-800 text-white font-bold uppercase tracking-wider py-6"
                data-testid="contact-submit-btn"
              >
                <PaperPlaneTilt size={18} className="mr-2" />
                {sending ? 'Invio in corso...' : 'Invia messaggio'}
              </Button>
            </form>
          </>
        )}
      </main>
    </div>
  );
}
